export const isChatOpened = (state) => state.chat.opened
